module.exports = __webpack_public_path__ + "static/itsm_capabilities_10-850d8a3bdb10553bac86fa3345291ab0.png";